const GOOGLE_MAPS_SCRIPT_ID = 'escort-google-maps-script';
const GOOGLE_MAPS_LIBRARIES = 'places,directions';

let googleMapsScriptPromise = null;

const buildGoogleMapsError = (code) => {
    const error = new Error(code);
    error.code = code;

    return error;
};

export const getGoogleMapsApiKey = () => {
    const runtimeKey = typeof window !== 'undefined'
        ? (window.googleMapsApiKey || window.settings?.google_maps_api_key || '')
        : '';

    const compileTimeKey = typeof process !== 'undefined' && process.env
        ? (process.env.MIX_GOOGLE_MAPS_API_KEY || '')
        : '';

    return String(runtimeKey || compileTimeKey || '').trim();
};

export const getGoogleMapsErrorTranslationKey = (error) => {
    if (error?.code === 'google_maps_api_key_missing') {
        return 'google_maps_api_key_missing';
    }

    if (error?.code === 'google_maps_failed_to_load') {
        return 'google_maps_failed_to_load';
    }

    return 'failed_response';
};

export const loadGoogleMapsScript = () => {
    if (typeof window !== 'undefined' && window.google?.maps) {
        return Promise.resolve(window.google.maps);
    }

    if (googleMapsScriptPromise) {
        return googleMapsScriptPromise;
    }

    googleMapsScriptPromise = new Promise((resolve, reject) => {
        const resolveMaps = () => {
            if (typeof window !== 'undefined' && window.google?.maps) {
                resolve(window.google.maps);
                return;
            }

            googleMapsScriptPromise = null;
            reject(buildGoogleMapsError('google_maps_failed_to_load'));
        };

        const rejectMaps = () => {
            googleMapsScriptPromise = null;
            reject(buildGoogleMapsError('google_maps_failed_to_load'));
        };

        const existingScript = document.getElementById(GOOGLE_MAPS_SCRIPT_ID);

        if (existingScript) {
            if (existingScript.dataset.loaded === 'true') {
                resolveMaps();
                return;
            }

            existingScript.addEventListener('load', resolveMaps, { once: true });
            existingScript.addEventListener('error', rejectMaps, { once: true });
            return;
        }

        const apiKey = getGoogleMapsApiKey();

        if (!apiKey) {
            googleMapsScriptPromise = null;
            reject(buildGoogleMapsError('google_maps_api_key_missing'));
            return;
        }

        const script = document.createElement('script');
        script.id = GOOGLE_MAPS_SCRIPT_ID;
        script.src = `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(apiKey)}&libraries=${GOOGLE_MAPS_LIBRARIES}`;
        script.async = true;
        script.defer = true;
        script.addEventListener('load', () => {
            script.dataset.loaded = 'true';
            resolveMaps();
        }, { once: true });
        script.addEventListener('error', rejectMaps, { once: true });
        document.head.appendChild(script);
    });

    return googleMapsScriptPromise;
};
